import Dispatch from "nexia_mobile/flux_like/dispatch";
import Store, { setValueAtPath } from "nexia_mobile/flux_like/store";
import { currentlyConfiguring724 } from "nexia_mobile/api/xr724";
import { currentlyConfiguringDragonfly } from "nexia_mobile/api/dragonfly";
import LocalSettings from "nexia_mobile/models/local_settings";
import Platform from "nexia_mobile/platform";
import BaseModel from "nexia_mobile/models/base_model";
import { history } from "nexia_mobile/history";

function isPollingDisabled() {
  return (
    Store.isAppPaused ||
    Store.isPlayingVideo ||
    Store.appState.inDemoMode ||
    currentlyConfiguring724() ||
    currentlyConfiguringDragonfly() ||
    Store.locationPolling.disableStack !== 0
  );
}

let timeoutReference;
let inFlightLocationPoll;

function enqueueNextPoll() {
  const pollingInterval = LocalSettings.getEventStreamingEnabled()
    ? 60000
    : 20000;
  const delay = LocalSettings.getFastPolling() ? 4000 : pollingInterval;
  clearTimeout(timeoutReference); // in case enqueueNextPoll is called multiple times
  timeoutReference = setTimeout(() => {
    Dispatch("LOCATION_POLL_TIMER");
    enqueueNextPoll();
  }, delay);
}

function showPollMessage(message) {
  if (LocalSettings.getShowPolling()) {
    Dispatch("SHOW_TOAST", message);
  }
}

Dispatch.on("SETUP_LOCATION_POLLING", () => enqueueNextPoll());

Dispatch.on("TEARDOWN_LOCATION_POLLING", () => {
  clearTimeout(timeoutReference);
});

// We use a stack to keep track of polling disabled state so that if multiple things
// disable it at once, then it doesn't get enabled again until they all call enable.
// If the stack is 0, polling is enabled.
Dispatch.on("DISABLE_LOCATION_POLLING", () => {
  setValueAtPath(
    "locationPolling.disableStack",
    Store.locationPolling.disableStack + 1
  );
  // Abort in-flight requests so that whatever important change is happening now
  // is reflected in future polls
  if (inFlightLocationPoll) {
    inFlightLocationPoll.abort();
  }
});

Dispatch.on("ENABLE_LOCATION_POLLING", () => {
  setValueAtPath(
    "locationPolling.disableStack",
    Math.max(0, Store.locationPolling.disableStack - 1)
  );
});

function currentlyViewingPhones() {
  return history.location.pathname.startsWith("/app/phones");
}

Dispatch.on("LOCATION_POLL_TIMER", () => {
  const location = Store.appState.currentLocation;
  if (isPollingDisabled() || !location) {
    return;
  }

  if (currentlyViewingPhones()) {
    const phones = Store.session.get("phones");
    /* eslint-disable no-empty-function */
    if (phones) phones.fetch().catch(() => {});
    /* eslint-enable no-empty-function */
  }

  // Use a dummy model to do the polling fetch, so we're able to cancel
  // the model.set after the request finishes in case polling was disabled
  // during the request
  const dummyModel = new BaseModel();
  dummyModel.setUrl(location.url());
  dummyModel.setAsEphemeral();
  const startTime = Date.now();
  showPollMessage("Poll start.");
  inFlightLocationPoll = dummyModel.fetch();
  inFlightLocationPoll
    .then((response) => {
      inFlightLocationPoll = null;
      if (isPollingDisabled()) {
        return;
      }
      const pollTime = Date.now() - startTime;
      showPollMessage(`Poll finish. Took ${pollTime} ms.`);
      Platform.addToSessionCache(response);

      location.set(location.parse(response));
      if (!location.get("hasParsedChildCollections")) {
        location.on("change:hasParsedChildCollections", () => {
          if (!location.get("hasParsedChildCollections")) {
            return;
          }
          location.off("change:hasParsedChildCollections");
          location
            .populatePendingRequestsRecursively()
            .then(() => {
              Dispatch("LOCATION_POLL_FINISHED");
            })
            .catch(() => {
              Dispatch("LOCATION_POLL_FINISHED");
            });
        });
      }
    })
    .catch(() => {
      inFlightLocationPoll = null;
      // ignore aborted requests
    });
});



// WEBPACK FOOTER //
// ./src/flux_like/action_handlers/polling.js